module.exports = __webpack_public_path__ + "img/avatar2.df91c7b5.png";